import firebase from "firebase/app"
import "firebase/auth"

// this has been extracted from auth services due to cyclical dependency issues
export const getCurrentAuthUser = () => firebase.auth().currentUser
